@if (!isChild()) {
  <div class="documents-toolbar">
    @if (
      (onlyExpiredContractsAndActiveMembership$ | async) === false &&
      (numberOfContracts$ | async) > 0
    ) {
      <rs-web-contract-picker
        class="documents-toolbar__contract-select"
        [class.documents-toolbar__contract-select--single]="hasSingleContract()"
        [contracts]="contractOptions()"
        [unreadContractIds]="unreadContractIds()"
        [contractId]="selectedContractId()"
        (contractIdChange)="selectContract($event)"
      ></rs-web-contract-picker>
    }
    @if (
      documentSortSupported() &&
      (sharedContent()?.folders?.length || sharedContent()?.documents?.length)
    ) {
      <rs-web-sorting-menu [type]="sortTypes.DOCUMENTS"></rs-web-sorting-menu>
    }
  </div>
}

@if (sharedContent()) {
  <div class="d-flex flex-column" [class.d-block]="!previewOpen()" [class.d-none]="previewOpen()">
    @if (sharedContent().breadcrumbs.length > 1) {
      <div class="d-flex align-items-center mb-3">
        <i
          class="icon-arrow-left d-flex title-s color-primary"
          (press)="
            openFolder(sharedContent().breadcrumbs[sharedContent().breadcrumbs.length - 2].id)
          "
          rsWebA11yPress
          [focusable]="true"
        ></i>
        <div class="mx-2 default-s">
          @for (breadcrumb of sharedContent().breadcrumbs; track breadcrumb.id) {
            <span
              class="breadcrumb-item"
              [class.clickable]="!$last"
              (press)="!$last && openFolder(breadcrumb.id)"
              rsWebA11yPress
              [focusable]="!$last"
            >
              {{ $index === 0 ? ('shared_content_header_l' | translate) : breadcrumb.name }}
            </span>
            @if (!$last) {
              <span class="mx-1 color-primary">/</span>
            }
          }
        </div>
      </div>
    }
    @for (folder of sharedContent().folders; track folder.id) {
      <div
        [elevation]="2"
        rsWebElevation
        class="folders"
        (press)="openFolder(folder.id)"
        rsWebA11yPress
        [focusable]="true"
      >
        <div class="icon me-3">
          <rs-web-icon [icon]="immomioIconName.FolderOutlined"></rs-web-icon>
        </div>
        <span class="primary-text">{{ folder.name }}</span>
        @if (folder.unreadDocumentCount) {
          <span class="unread-badge">{{ folder.unreadDocumentCount }}</span>
        }
      </div>
    }
    @for (document of sharedContent().documents; track document.id) {
      <div
        [elevation]="2"
        rsWebElevation
        class="documents"
        (press)="preview(document)"
        rsWebA11yPress
        [focusable]="true"
      >
        <div class="icon me-3">
          <rs-web-icon [icon]="immomioIconName.Document"></rs-web-icon>
        </div>
        <span class="primary-text" [class.fw-bold]="document.unread">{{ document.name }}</span>
        @if (document.unread) {
          <span class="unread-dot"></span>
        }
        <span class="ms-auto">{{ document.sharedWithMeAt | date: 'dd.MM.yyyy' }}</span>
      </div>
    }
  </div>
} @else {
  @if (isContentLoading()) {
    @if (!isChild()) {
      <rs-web-loading-skeleton
        [show]="true"
        [types]="[LoadingType.DOCUMENT]"
      ></rs-web-loading-skeleton>
    } @else {
      <div class="sub-folder">
        <rs-web-loading-skeleton
          [show]="true"
          [types]="[LoadingType.DOCUMENT]"
        ></rs-web-loading-skeleton>
      </div>
    }
  } @else {
    <ng-container *ngTemplateOutlet="noData"></ng-container>
  }
}

<ng-template #noData>
  <div class="no-documents-view">
    <div class="no-documents-view__box">
      <rs-web-whitelabel-image
        [whitelabelImage]="whitelabelImage.WAITING"
        [altTag]="WhitelabelImageAltTag.WAITING | translate"
      ></rs-web-whitelabel-image>
      <h1 class="text-center primary-text" [innerHTML]="'documents.no_documents' | translate"></h1>
      <p
        class="text-center primary-text"
        [innerHTML]="'documents.no_documents_helper_text' | translate"
      ></p>
    </div>
  </div>
</ng-template>
